import axios from 'axios'

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || (window.location.hostname.includes('.com') ? 'https://api.banjinos.com/api' : 'https://api.banjinos.dev/api'),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  config => {
    // Get token from localStorage
    const token = localStorage.getItem('b2b_token') || localStorage.getItem('token')
    const userStr = localStorage.getItem('b2b_user') || localStorage.getItem('user')
    
    console.log('🔐 Axios Interceptor Debug:', {
      hasB2BToken: !!localStorage.getItem('b2b_token'),
      hasToken: !!localStorage.getItem('token'),
      tokenFound: !!token,
      tokenLength: token?.length,
      url: config.url
    })
    
    if (token) {
      // Check if token already has Bearer prefix
      if (token.startsWith('Bearer ')) {
        config.headers.Authorization = token
      } else {
        config.headers.Authorization = `Bearer ${token}`
      }
      console.log('✅ Added Authorization header')
    } else {
      console.error('❌ No token found in localStorage!')
    }
    
    if (userStr) {
      try {
        const user = JSON.parse(userStr)
        if (user.clientType) {
          config.headers['X-Client-Type'] = user.clientType
        }
      } catch (e) {
        console.error('Failed to parse user data:', e)
      }
    }
    
    // Debug log for API calls
    console.log('API Request:', {
      url: config.url,
      method: config.method,
      headers: {
        Authorization: config.headers.Authorization ? 'Bearer ...' : 'Missing',
        'X-Client-Type': config.headers['X-Client-Type'] || 'Missing'
      }
    })
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Handle 401 errors - but don't auto-logout on dashboard endpoints
    if (error.response?.status === 401) {
      const url = error.config?.url || ''
      
      // Don't auto-logout for dashboard endpoints - let the component handle it
      if (url.includes('/dashboard/')) {
        console.warn('Dashboard API auth error - may need different permissions')
        return Promise.reject(error)
      }
      
      // For other endpoints, check if we're already on login page
      if (!window.location.pathname.includes('/login')) {
        // Token expired or invalid
        localStorage.removeItem('b2b_token')
        localStorage.removeItem('b2b_user')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        
        // Redirect to login
        window.location.href = '/login'
      }
    }
    
    return Promise.reject(error)
  }
)

export default axiosInstance